import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { importProgressJobs } from "./ImportProgressJobsStore";
import { ReactComponent as Contacts } from "Assets/svg/jobProgressPopup/contacts.svg";
import { useHistory } from "react-router-dom";
import Utils from "Utils/utils";

const ImportProgressPopup = observer(() => {
  const history = useHistory();
  const [jobs, setJobs] = useState([]);
  const [liJobs, setLiJobs] = useState([]);
  const [csvJobs, setCsvJobs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const closeCbk = () => {
    importProgressJobs.setIsShowPopup(false);
  };

  const redirectToImport = () => {
    history.push("/settings/imports/csv");
    closeCbk();
  };

  const populateJobs = () => {
    let totalLiJobs = [];
    let totalCsvJobs = [];
    if (liJobs && liJobs.length > 0) {
      totalLiJobs = importProgressJobs?.liImportJobs.map((job, ind) => {
        const filteredData = Object.keys(job.job)
          .filter(
            key => key.includes("status") || key.includes("totalContacts")
          )
          .reduce((object, key) => {
            return Object.assign(object, {
              [key]: job.job[key]
            });
          }, {});
        const progressPercentage = {
          progress: job?.progressPercent,
          type: "LINKEDIN"
        };
        return {
          name: "LinkedIn Sales Navigator",
          contacts: filteredData?.totalContacts || 0,
          status: filteredData?.status === "IN_PROGRESS" ? "active" : "queued",
          ...progressPercentage
        };
      });
    }
    if (csvJobs && csvJobs.length > 0) {
      totalCsvJobs = importProgressJobs?.csvImportJobs.map((job, ind) => {
        const filteredCsvData = Object.keys(job)
          .filter(
            key =>
              key.includes("status") ||
              key.includes("csvFileName") ||
              key.includes("progressPercent") ||
              key.includes("totalContacts")
          )
          .reduce((object, key) => {
            return Object.assign(object, {
              [key]: job[key]
            });
          }, {});
        const type = {
          type: "CSV"
        };
        return {
          name: filteredCsvData?.csvFileName || "",
          contacts: filteredCsvData?.totalContacts || 0,
          status:
            filteredCsvData?.status === "INPROGRESS" ? "active" : "queued",
          progress: filteredCsvData?.progressPercent || 0,
          ...type
        };
      });
    }
    setJobs([...totalLiJobs, ...totalCsvJobs]);
  };

  useEffect(() => {
    populateJobs();
  }, [liJobs, csvJobs]);

  useEffect(() => {
    setLiJobs(importProgressJobs?.liImportJobs);
  }, [importProgressJobs?.liImportJobs]);

  useEffect(() => {
    setCsvJobs(importProgressJobs?.csvImportJobs);
  }, [importProgressJobs?.csvImportJobs]);

  useEffect(() => {
    setIsLoading(jobs.length === 0);
  }, [jobs]);

  return (
    <>
      {importProgressJobs?.isShowPopup && (
        <>
          <div className="pullContactsMask" onClick={closeCbk} />
          <div className="pullContactsWrapper">
            <div className="jobProgresscard">
              <i className="material-icons closeIcon" onClick={closeCbk}>
                close
              </i>
              <div className="uploadingContactsText">
                <div className="contactsIcon">
                  <Contacts />
                </div>
                <div className="contactsText">Uploading Contacts</div>
              </div>
              <div className="importJobsWrapper">
                {isLoading
                  ? Array.from({ length: 2 }, (_, index) => (
                      <div className="importJob" key={index}>
                        <div className="importJobInner">
                          <div className="importJobName linear-background"></div>

                          <div className="importJobProgressWrapper">
                            <div className="linearProgressBarWrapper">
                              <div className="linearProgressBar linear-background"></div>
                              <div className="progressPercentage linear-background"></div>
                              <div className="jobStatus linear-background"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  : jobs?.map((job, index) => (
                      <div className="importJob" key={index}>
                        <div className="importJobInner">
                          <div className="importJobName">
                            {job?.progress > 0
                              ? "Importing"
                              : "Initializing upload"}{" "}
                            {job?.type === "LINKEDIN"
                              ? `${
                                  !job?.progress > 0 ? " of " : ""
                                }${Utils.formatNumberToString(
                                  job?.contacts
                                )} contacts`
                              : job?.type === "CSV" && job?.progress > 0
                              ? `${Utils.formatNumberToString(
                                  job?.contacts
                                )} contacts`
                              : ""}{" "}
                            from {job?.name}
                          </div>
                          <div className="importJobProgressWrapper">
                            <div className="linearProgressBarWrapper">
                              <div className="linearProgressBar">
                                <div className="backgroundProgress"></div>
                                <div
                                  className={`linearProgress ${
                                    job?.progress > 10 ? "applyTransition" : ""
                                  }`}
                                  style={{ width: `${job?.progress}%` }}
                                ></div>
                              </div>
                              <div className="progressPercentage">{`${Math.round(
                                job?.progress
                              )}%`}</div>
                              <div className={`jobStatus ${job?.status}`}>
                                <div className="jobStatusText">
                                  {job.status === "active"
                                    ? "Active"
                                    : "Queued"}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
              </div>
              <div onClick={redirectToImport} className="importsRedirection">
                <div className="importsRedirectionText">
                  View all uploads in Imports →
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
});

export default ImportProgressPopup;
